import { useLanguage } from '../../context/LanguageContext';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

export default function RodoClause() {
  const { language } = useLanguage();

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10" data-testid="rodo-clause-page">
      <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-[#1B3A7B] hover:underline mb-6">
        <ChevronLeft className="w-4 h-4" />
        {language === 'pl' ? 'Powrot do kalkulatora' : 'Back to calculator'}
      </Link>

      <h1 className="text-3xl sm:text-4xl font-heading font-bold text-[#1B3A7B] mb-8">
        {language === 'pl' ? 'Klauzula informacyjna RODO' : 'GDPR Information Clause'}
      </h1>

      <div className="prose prose-slate max-w-none space-y-6 text-sm leading-relaxed text-slate-700">
        <p className="text-slate-500 text-xs">Zgodnie z art. 13 ust. 1 i 2 Rozporzadzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. (RODO)</p>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">1. Administrator danych</h2>
          <p>Administratorem Panstwa danych osobowych jest <strong>Biuro Rachunkowe Kurdynowski</strong>.</p>
          <p>Kontakt: <a href="mailto:monika.gawkowska@kurdynowski.pl" className="text-[#1B3A7B] hover:underline">monika.gawkowska@kurdynowski.pl</a></p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">2. Cel i podstawa prawna przetwarzania</h2>
          <p>Panstwa dane osobowe przetwarzane sa w celu:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Wykonania uslugi wyceny</strong> &mdash; na podstawie art. 6 ust. 1 lit. b RODO (niezbednosc do wykonania umowy lub podjecia dzialan przed jej zawarciem)</li>
            <li><strong>Kontaktu w celu przedstawienia oferty</strong> &mdash; na podstawie art. 6 ust. 1 lit. a RODO (zgoda wyrazona przez uzytkownika)</li>
            <li><strong>Przesylania wyceny droga e-mail</strong> &mdash; na podstawie art. 6 ust. 1 lit. a RODO (zgoda)</li>
            <li><strong>Realizacji obowiazkow prawnych</strong> &mdash; na podstawie art. 6 ust. 1 lit. c RODO</li>
            <li><strong>Dochodzenia lub obrony roszczen</strong> &mdash; na podstawie art. 6 ust. 1 lit. f RODO (prawnie uzasadniony interes)</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">3. Odbiorcy danych</h2>
          <p>Dane moga byc przekazywane nastepujacym kategoriom odbiorcow:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Dostawcy uslug hostingowych i IT</li>
            <li>Dostawcy uslug e-mail (w celu wysylki wycen)</li>
            <li>Podmioty uprawnione na podstawie przepisow prawa</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">4. Okres przechowywania</h2>
          <p>Dane osobowe beda przechowywane:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>W przypadku zgody &mdash; do momentu jej wycofania</li>
            <li>W przypadku umowy &mdash; przez okres trwania umowy i okres przedawnienia roszczen</li>
            <li>W przypadku obowiazku prawnego &mdash; przez okres wymagany przepisami prawa</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">5. Prawa osob, ktorych dane dotycza</h2>
          <p>Maja Panstwo prawo do:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Dostepu do swoich danych osobowych</li>
            <li>Sprostowania danych</li>
            <li>Usuniecia danych</li>
            <li>Ograniczenia przetwarzania</li>
            <li>Przenoszenia danych</li>
            <li>Wniesienia sprzeciwu wobec przetwarzania</li>
            <li>Cofniecia zgody w dowolnym momencie (bez wplywu na zgodnosc z prawem przetwarzania dokonanego przed cofnieciem)</li>
            <li>Wniesienia skargi do Prezesa Urzedu Ochrony Danych Osobowych (ul. Stawki 2, 00-193 Warszawa)</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">6. Dobrowolnosc podania danych</h2>
          <p>Podanie danych osobowych jest dobrowolne, jednak niezbedne do skorzystania z kalkulatora wyceny oraz otrzymania oferty uslug ksiegowych.</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[#1B3A7B] mt-6 mb-3">7. Zautomatyzowane podejmowanie decyzji</h2>
          <p>Panstwa dane nie beda podlegaly zautomatyzowanemu podejmowaniu decyzji, w tym profilowaniu w rozumieniu art. 22 RODO.</p>
        </section>
      </div>
    </div>
  );
}
